import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import DuplicateContactModal from "./DuplicateContactModal";
import {
  DUPLICATE_CONTACT_EVENT,
  duplicateCardPath,
  duplicateContactPath,
} from "../../utils/duplicateContact";

// Ouve `relinq:duplicate-contact` (disparado por `openDuplicateContact`) e abre a
// mini modal do contato repetido. Montado uma vez em `routes/Container.jsx`, para
// valer em toda tela autenticada e acima do formulário que tentou criar o contato.
const GlobalDuplicateContact = () => {
  const navigate = useNavigate();
  const [state, setState] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      const detail = event?.detail;
      if (detail?.conflict?.lead?.id) setState(detail);
    };
    window.addEventListener(DUPLICATE_CONTACT_EVENT, handler);
    return () => window.removeEventListener(DUPLICATE_CONTACT_EVENT, handler);
  }, []);

  const close = useCallback(() => setState(null), []);

  const go = useCallback(
    (path) => {
      const onOpen = state?.onOpen;
      setState(null);
      if (typeof onOpen === "function") onOpen();
      navigate(path);
    },
    [navigate, state],
  );

  if (!state) return null;
  return (
    <DuplicateContactModal
      conflict={state.conflict}
      message={state.message}
      onClose={close}
      onOpenContact={() => go(duplicateContactPath(state.conflict.lead.id))}
      onOpenCard={(card) => go(duplicateCardPath(card))}
    />
  );
};

export default GlobalDuplicateContact;
